/*
 * @Author: your name
 * @Date: 2020-05-07 08:57:54
 * @LastEditTime: 2020-11-18 13:24:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \HNQX_YWNWc:\Users\admin\Desktop\产品库\src\router\index.js
 */

import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

let router = new Router({
    routes: [{
            path: '*',
            redirect: '/lalu'
        },
        // {
        //     path: '/login',
        //     name: 'login',
        //     component: () =>
        //         import ('../page/login/index'),

        // },
        {
            path: '/lalu',
            name: 'lalu',
            component: () =>
                import ('../page/login/mapInp')
        },
        {
            path: '/',
            name: 'lalu',
            component: () =>
                import ('../page/login/mapInp')
        },
        // {
        //     path: '/',
        //     name: 'zhangzhou',
        //     component: () =>
        //         import ('../page/login/mapInpZZ')
        // },
    ]
})

router.beforeEach((to, from, next) => {
    next()
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js